import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import { adminTenantsQueryOptions } from "./tenants.queries";
import type { AdminTenant } from "./tenants.types";

export const setTenantPlanMutation = mutationOptions({
	mutationFn: (vars: { id: string; rateTier: AdminTenant["rateTier"] }) =>
		api.post(`/platform/admin/tenants/${vars.id}/plan`, {
			rateTier: vars.rateTier,
		}),
	onSuccess: () =>
		Promise.all([
			queryClient.invalidateQueries({
				queryKey: adminTenantsQueryOptions.queryKey,
			}),
			// rate tier changes revenue, so refresh the telemetry dashboard too
			queryClient.invalidateQueries({ queryKey: ["admin", "telemetry"] }),
		]),
});
